<section class="pygTeaserBg py-14 lg:py-20">
  <div class="w-10/12 sm:w-9/12 mx-auto flex flex-wrap lg:flex-nowrap items-center gap-10">
    <div class="w-full lg:w-7/12">
      <h2 class="pygTeaserHeading">{{ "main_page.platform_teaser.title" | translate }}</h2>
      <p class="pt-4 pb-8 max-w-lg">
        {{ "main_page.platform_teaser.subtitle" | translate }}
      </p>
      <a
        langRouterLink="platform"
        class="pygTeaserBtn inline-block"
      >{{ "main_page.platform_teaser.cta" | translate }}</a>
    </div>
    <div class="w-full lg:w-5/12">
      <div class="pygPipelineCard">
        <div class="pygPipelineFlow">
          @for (step of pipelineSteps; track step.icon; let i = $index; let last = $last) {
            <div class="pygPipelineNode">
              <div class="pygPipelineNodeCircle" [style.animation-delay]="(i * 0.4) + 's'">
                <ng-icon [name]="step.icon" style="font-size: 1.125rem"></ng-icon>
              </div>
              <span class="pygPipelineNodeLabel">{{ step.labelKey | translate }}</span>
            </div>
            @if (!last) {
              <div class="pygPipelineLine" [style.animation-delay]="(i * 0.8 + 0.3) + 's'"></div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</section>
